var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgViewIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1_48686)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.0505 3.17383C5.04812 3.17383 2.3254 4.81646 0.316316 7.48453C0.152374 7.70312 0.152374 8.0085 0.316316 8.22709C2.3254 10.8984 5.04812 12.541 8.0505 12.541C11.0529 12.541 13.7756 10.8984 15.7847 8.2303C15.9486 8.01171 15.9486 7.70633 15.7847 7.48774C13.7756 4.81646 11.0529 3.17383 8.0505 3.17383ZM8.26588 11.1555C6.27286 11.2809 4.62702 9.63827 4.75238 7.64204C4.85525 5.9962 6.18928 4.66216 7.83513 4.5593C9.82814 4.43393 11.474 6.07656 11.3486 8.07279C11.2425 9.71542 9.90851 11.0495 8.26588 11.1555ZM8.16623 9.63184C7.09257 9.69935 6.20536 8.81535 6.27608 7.74169C6.33072 6.85448 7.05078 6.13763 7.93799 6.07977C9.01165 6.01227 9.89886 6.89627 9.82814 7.96992C9.77028 8.86035 9.05022 9.57719 8.16623 9.63184Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1_48686"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 15.7143,
    height: 15.7143,
    fill: "white",
    transform: "translate(0.191406)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgViewIcon);
export default __webpack_public_path__ + "static/media/view-icon.93370132179dc78ab8051ae522f3422e.svg";
export { ForwardRef as ReactComponent };